/**
 * PURPOSE: Consumir endpoints Hayllis V2 de información pública por disciplina desde Winscore.
 * RESPONSIBILITIES: Leer/guardar información, cargar sedes candidatas e instituciones participantes para formularios.
 * COLLABORATORS: CardConfigSportInformation.jsx, API_BASE_URL y backend/src/hayllis-v2/sport-information.
 * ROUTE: src/services/hayllisV2SportInformationService.js
 */
import axios from "axios";
import API_BASE_URL from "../config/config.js";

const basePath = ({ idevent, idsport }) => `${API_BASE_URL}/api/hayllis/v2/events/${idevent}/sports/${idsport}/information`;

const unwrap = (response) => response.data?.data || response.data;

const normalizeArrayResponse = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.sedes)) return payload.sedes;
  if (Array.isArray(payload?.venues)) return payload.venues;
  if (Array.isArray(payload?.data?.venues)) return payload.data.venues;
  if (Array.isArray(payload?.institutions)) return payload.institutions;
  if (Array.isArray(payload?.participants)) return payload.participants;
  return [];
};

export const getSportInformation = async ({ idevent, idsport }) => {
  try {
    const response = await axios.get(basePath({ idevent, idsport }));
    if (response.status === 204) return { information: null };
    return unwrap(response) || { information: null };
  } catch (error) {
    // Un deporte todavía no configurado es un estado vacío válido, no un fallo.
    if ([404, 204].includes(Number(error?.response?.status))) {
      return { information: null };
    }
    throw error;
  }
};

export const updateSportInformation = async ({ idevent, idsport, payload }) => {
  const response = await axios.patch(basePath({ idevent, idsport }), payload);
  return unwrap(response);
};

export const listVenueOptions = async ({ idevent, iddepartamento } = {}) => {
  try {
    const params = {
      ...(idevent ? { idevent: Number(idevent) } : {}),
      ...(iddepartamento ? { iddepartamento: Number(iddepartamento) } : {}),
    };

    const response = await axios.get(`${API_BASE_URL}/api/hayllis/v2/venues`, {
      params: Object.keys(params).length ? params : undefined,
    });

    return normalizeArrayResponse(unwrap(response));
  } catch (error) {
    console.error("Error loading Hayllis V2 venues", error);
    return [];
  }
};

export const listParticipantInstitutionOptions = async ({ idevent, idsport }) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/getparticipants`, {
      idevent: Number(idevent),
      idsport: Number(idsport),
      idtypephase: 1,
    });

    const participants = normalizeArrayResponse(response.data);
    const seen = new Set();

    return participants
      .map((participant) => participant.Institution || participant.institution || participant)
      .filter((institution) => {
        const id = Number(institution?.idinstitution || institution?.id);
        if (!id || seen.has(id)) return false;
        seen.add(id);
        return true;
      });
  } catch (_error) {
    return [];
  }
};
